import React from "react";
import {
  Box,
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Image,
} from "@chakra-ui/react";
import iconoir_filter from "../../../assets/waveflowmain/iconoir_filter.png";

const FilterComponent = ({ selectedFilter, setSelectedFilter }) => {
  const categories = ["All", "Together", "Groq", "OpenAI", "Mistral"];

  return (
    <Box>
      <Menu>
        <MenuButton
          p={0}
          m={0}
          size="sm"
          _hover={{ bg: "none" }}
          as={Button}
        >
          <Image src={iconoir_filter} alt="Filter" />
        </MenuButton>
        <MenuList>
          {categories.map((category) => (
            <MenuItem
              key={category}
              onClick={() => setSelectedFilter(category)}
              bg={selectedFilter === category ? "gray.100" : "transparent"}
            >
              {category}
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
    </Box>
  );
};

export default FilterComponent;
